import gql from 'graphql-tag'

export const getMe = gql`
  query {
    me {
      id
      username
      emails
      userType
      contactName
      contactPhone
      phoneCountryCode
      phoneCountryCallingCode
      phoneExtensionNumber
      contactFax
      faxCountryCode
      faxCountryCallingCode
      faxExtensionNumber
      contactEmail
    }
  }
`

export const getGoogleAuthUrl = gql`
  query {
    getGoogleAuthUrl
  }
`

export const getUsers = gql`
  query($paging: PagingQuery, $order: UsersOrder, $filter: UsersFilter) {
    getUsers(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      users {
        id
        username
        emails
        userType
        contactName
        contactPhone
        phoneCountryCode
        phoneCountryCallingCode
        phoneExtensionNumber
        contactFax
        faxCountryCode
        faxCountryCallingCode
        faxExtensionNumber
        contactEmail
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const getAllUsers = gql`
  query($nameFilter: String) {
    getAllUsers(
      nameFilter: $nameFilter,
    ) {
      id
      username
    }
  }
`

export const signIn = gql`
  mutation($password: String!, $username: String!) {
    signIn(
      password: $password,
      username: $username
    ) {
      id
      username
      emails
      userType
      contactName
      contactPhone
      phoneCountryCode
      phoneCountryCallingCode
      phoneExtensionNumber
      contactFax
      faxCountryCode
      faxCountryCallingCode
      faxExtensionNumber
      contactEmail
      jwt
      createdAt
      updatedAt
    }
  }
`

export const signInWithGoogle = gql`
  mutation($authCode: String!) {
    signInWithGoogle(
      authCode: $authCode
    ) {
      id
      username
      emails
      userType
      contactName
      contactPhone
      phoneCountryCode
      phoneCountryCallingCode
      phoneExtensionNumber
      contactFax
      faxCountryCode
      faxCountryCallingCode
      faxExtensionNumber
      contactEmail
      jwt
      createdAt
      updatedAt
    }
  }
`

export const newUser = gql`
  mutation($userInput: NewUserInput!) {
    newUser(
      userInput: $userInput
    ) {
      id
      username
      emails
      userType
    }
  }
`

export const editUser = gql`
  mutation($userInput: EditUserInput!, $userId: Int!) {
    editUser(
      userInput: $userInput,
      userId: $userId
    ) {
      id
      username
      emails
      userType
    }
  }
`

export const deleteUserById = gql`
  mutation($userId: Int!) {
    deleteUserById(
      userId: $userId
    )
  }
`

export const resetUserPassword = gql`
  mutation($userId: Int!, $newPassword: String!) {
    resetUserPassword(
      userId: $userId,
      newPassword: $newPassword
    )
  }
`

export const editSelfPassword = gql`
  mutation($newPassword: String!, $oldPassword: String!) {
    editSelfPassword(
      newPassword: $newPassword
      oldPassword: $oldPassword
    )
  }
`
